import ajax from './axios'
export const getSubjecList = () => {
    return ajax.get('/api/v2/search/subject')
}

export const getSearchData = (params) => {
    return ajax.get('/api/v2/search/project', { params })
}

export const getDetailsData = (id) => {
    return ajax.get('/api/v2/search/details?id=' + id)
}

export const getSearchChart = (keyword) => {
    return ajax.get('/api/v2/trends/keyword?keyword=' + keyword)
}


// WEBPACK FOOTER //
// ./src/api/nsfc.js